import _ from "lodash";
import { useCallback, useEffect, useState } from "react";

import { fetchOptOutPhraseList } from "~frontend/util/optOutPhrases";

export default function useOptOutPhraseList():
  | {
      phraseList: string[];
      loading: false;
    }
  | { phraseList: null; loading: true } {
  const [phraseList, setPhraseList] = useState<string[] | null>(null);

  const fetchAndSetPhraseList = useCallback(async () => {
    setPhraseList(await fetchOptOutPhraseList());
  }, [setPhraseList]);

  useEffect(() => {
    if (!phraseList) {
      void fetchAndSetPhraseList();
    }
  }, [phraseList, fetchAndSetPhraseList]);

  return phraseList
    ? { loading: false, phraseList }
    : { loading: true, phraseList };
}
